module.exports = __webpack_public_path__ + "assets/galaxy-desc.2ae80e53.svg";